import { Box } from '@mui/system'
import { CircularProgress } from '@mui/material'
import Fingerprint from '@mui/icons-material/Fingerprint'
import FaceRetouchingNatural from '@mui/icons-material/FaceRetouchingNatural'
import OfoqThemeBtn from '../../../components/Buttons/OfoqThemeBtn'

const LABELS = {
  face: 'Log in with Face ID',
  fingerprint: 'Log in with fingerprint',
}

const ICONS = {
  face: FaceRetouchingNatural,
  fingerprint: Fingerprint,
}

const BiometricLoginButton = ({ type, loading, onClick, t }) => {
  if (!type) return null

  const Icon = ICONS[type]

  return (
    <Box sx={styles.container}>
      <OfoqThemeBtn
        customStyle={styles.button}
        cancelStyle
        disabled={loading}
        onClick={onClick}
        name={(
          <Box sx={styles.content}>
            {loading ? <CircularProgress size={18} /> : <Icon fontSize="small" />}
            {t?.[LABELS[type]] || LABELS[type]}
          </Box>
        )}
        fullWidth
      />
    </Box>
  )
}

const styles = {
  container: {
    width: '100%',
    mb: 2,
  },
  button: {
    maxWidth: '100%',
    height: '40px',
    ml: 0,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },
}

export default BiometricLoginButton
